<div class="header">
  <p>Vista previa</p>
  <img src="../../../assets/icons/cerrar.png" (click)="dialogRef.close()" alt="cerrar el modal" class="close" >
</div>
<iframe [src]="getUrlTemplatePreview()" title="description"></iframe>